import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback, DropdownItem } from 'reactstrap';
import { GetIndustries } from '../../../utils/ApplicationApi';
import FormSelect from '../../FormSelect/FormSelect';
import {isMobile} from 'react-device-detect';

class DescriptionField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      industryList: [],
      occupationList: [],
      isLoaded: false
    };

    this.occupationRef = React.createRef();

    this.handleIndustryChange = this.handleIndustryChange.bind(this);
    this.handleOccupationChange = this.handleOccupationChange.bind(this);
  }
  componentDidMount() {
    this.mounted = true;

    if(this.state.industryList.length === 0) {      
      GetIndustries().then(industryList => {  
        if(this.mounted) {
          this.setState({industryList: industryList, isLoaded: true});
          if(this.props.industry !=="") {
            const occupations = this.state.industryList.find(industry => industry.industry === this.props.industry);
            this.setState({
              occupationList: occupations !== undefined ? occupations.occupations : []
            });
          }
        }
      });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  handleIndustryChange(event) {
    const occupations = this.state.industryList.find(industry => industry.industry === event.target.value);
    this.setState({
      occupationList: occupations !== undefined ? occupations.occupations : []
    }, () => {
      this.occupationRef.current.focus();
    });
    this.props.handleChange(event);
  }
  handleOccupationChange(event) {
    const occupation = event.target.value.split("|")[0];
    const noc = event.target.value.split("|")[1];
    this.props.handleChange({target: {name: "occupationName", value: {occupationName: occupation, noc: noc}}});
  }
  render() {
    return (
      <div>
        <FormGroup>
          <Label for="industry">Select the industry that best describes what you do for a living</Label>
          {isMobile ? 
            <Input type="select" name="industry" value={this.props.industry} id="industry" onChange={this.handleIndustryChange} invalid={this.props.validation.industry.isInvalid} onBlur={this.props.validateField}> 
              <option value=""  disabled></option>
              {this.state.industryList.map((industry, i) => <option key={i}>{industry.industry}</option>)}
            </Input>
          :
            <FormSelect name="industry" handleChange={this.handleIndustryChange} value={this.props.industry} label={this.props.industry} isInvalid={this.props.validation.industry.isInvalid} validateField={this.props.validateField}>
              {this.state.industryList.map((industry, i) => <DropdownItem key={i} value={industry.industry}>{industry.industry}</DropdownItem>)}
            </FormSelect>
          }
          <FormFeedback>{this.props.validation.industry.message}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Label for="occupation">Occupation Title</Label>
          {isMobile ? 
            <Input type="select" innerRef={this.occupationRef} name="occupationName" id="occupation" value={this.props.occupationName === "" ? "" : `${this.props.occupationName}|${this.props.noc}`} onChange={this.handleOccupationChange} invalid={this.props.validation.occupationName.isInvalid} disabled={this.state.occupationList.length === 0 ? true : false} onBlur={this.props.validateField}>
              <option value="" disabled></option>
              {this.state.occupationList.map((occupation, i) => <option key={i} value={`${occupation.occupation}|${occupation.code}`}>{occupation.occupation}</option>)}
            </Input>
          :
            <FormSelect ref={this.occupationRef} name="occupationName" handleChange={this.handleOccupationChange} value={this.props.occupationName === "" ? "" : `${this.props.occupationName}|${this.props.noc}`} label={this.props.occupationName} isInvalid={this.props.validation.occupationName.isInvalid} validateField={this.props.validateField} disabled={this.state.occupationList.length === 0 ? true : false} >
              {this.state.occupationList.map((occupation, i) => <DropdownItem key={i} value={`${occupation.occupation}|${occupation.code}`}>{occupation.occupation}</DropdownItem>)}
            </FormSelect>
          }
          <FormFeedback>{this.props.validation.occupationName.message}</FormFeedback>
        </FormGroup>                                                    
      </div>);
  }
}
DescriptionField.defaultProps= {
  handleChange:() => {},
  validation: {
    industry: {
      isInvalid: false,
      message: ""
    },
    occupationName: {
      isInvalid: false,
      message: ""
    }
  }
};

DescriptionField.propTypes = {
  handleChange: PropTypes.func,
};

export default DescriptionField;


// WEBPACK FOOTER //
// ./src/components/Fields/Occupation/DescriptionField.js